import script from "./ProfileSelectionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileSelectionView.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileSelectionView.vue?vue&type=style&index=0&id=b5404616&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5404616"]])

export default __exports__